import { render } from "./AgentEditTicket.vue?vue&type=template&id=86244aae&scoped=true"
import script from "./AgentEditTicket.vue?vue&type=script&lang=js"
export * from "./AgentEditTicket.vue?vue&type=script&lang=js"

import "./AgentEditTicket.vue?vue&type=style&index=0&id=86244aae&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86244aae"]])

export default __exports__